class DateElements {
    dayOfMonth;
    monthValue;
    year;
    constructor(response) {
        this.dayOfMonth = response.dayOfMonth;
        this.monthValue = response.monthValue;
        this.year = response.year;
    }
    print() {
        let precision = "Y";
        if (this.monthValue !== undefined)
            precision = "YM";
        if (this.dayOfMonth !== undefined)
            precision = "YMD";
        const dateValue = new Date(Date.UTC(this.year ?? 2025, (this.monthValue ?? 1) - 1, this.dayOfMonth ?? 1));
        return { value: dateValue, options: { precision } };
    }
}
export default DateElements;
